module.exports = __webpack_public_path__ + "static/media/fullscreen.e51aa1fb.png";